import "./Profile.css";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { fetchProfileById } from "../lib/profileApi";
import gilbraterImage from "../gilbrater.jpg";

function Profile() {
  const { profileId } = useParams();
  const [profile, setProfile] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const loadProfile = async () => {
      try {
        setIsLoading(true);
        setErrorMessage("");
        const result = await fetchProfileById(profileId);
        setProfile(result);
      } catch (error) {
        setErrorMessage(error.message);
      } finally {
        setIsLoading(false);
      }
    };

    loadProfile();
  }, [profileId]);

  if (isLoading) {
    return (
      <div className="profile-page">
        <div className="profile-card">
          <h1>Loading profile...</h1>
        </div>
      </div>
    );
  }

  if (!profile) {
    return (
      <div className="profile-page">
        <div className="profile-card">
          <h1>Profile not found</h1>
          <p>{errorMessage || "The selected profile could not be loaded."}</p>
          <Link className="profile-back" to="/">
            Back to home
          </Link>
        </div>
      </div>
    );
  }

  const whatsmsg = encodeURIComponent(
 `Hi ${profile.name}, I found you on LunaPlane and I'm interested to knowing you more and services you offer.`
);

  return (
    <div className="profile-page">
      <div className="profile-card"> 
            <img
              className="profile-image"
              src={profile.image || gilbraterImage}
              alt={profile.name}
            />
            <div className="profile-content ">
              {/* <p className="profile-label">Profile</p> */}
              <h1>{profile.name.toUpperCase()}</h1>
              <p className="profile-location">{profile.location}</p>
              <p className="profile-description">{profile.description}</p>
              <p>Tel: {profile.tel}</p>
              <p>Age: {profile.ageRange}</p>
              <p>Nationality: {profile.nationality}</p>
              <p>Service: {profile.service}</p>
              <Link className="profile-back" to="/">
                Back to home
              </Link>
              <div className="profile-actions">
                <a href={`tel:${profile.tel}`} className="what profile-call">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" aria-hidden="true">
                    <circle cx="256" cy="256" r="216" stroke="currentColor" strokeWidth="28" fill="none" />
                    <path
                      d="M198 180 C210 168, 235 168, 247 180 C270 205, 255 235, 240 245 C230 252, 230 265, 238 275 C260 305, 290 335, 320 355 C330 362, 343 362, 350 355 C360 345, 390 330, 415 355 C427 367, 427 392, 415 404 L395 424 C365 454, 315 450, 270 420 C215 385, 170 330, 145 265 C125 210, 150 180, 180 165 Z"
                      fill="currentColor"
                    />
                  </svg>
                </a>
                <a
                  href={`https://wa.me/${profile.whatsapp}?text=${whatsmsg}`}
                  target="_blank"
                  rel="noreferrer"
                  className="what"
                >
                  <svg viewBox="0 0 32 32" aria-hidden="true">
                    <path d="M19.11 17.21c-.28-.14-1.64-.81-1.89-.9-.25-.09-.43-.14-.61.14-.18.28-.7.9-.85 1.09-.16.19-.31.21-.59.07-.28-.14-1.16-.43-2.21-1.38-.82-.73-1.38-1.64-1.54-1.92-.16-.28-.02-.43.12-.57.13-.13.28-.33.42-.49.14-.16.19-.28.28-.47.09-.19.05-.35-.02-.49-.07-.14-.61-1.47-.84-2.01-.22-.53-.45-.45-.61-.45h-.52c-.19 0-.49.07-.75.35-.26.28-.98.95-.98 2.31s1 2.68 1.14 2.87c.14.19 1.96 2.99 4.76 4.19.67.29 1.19.46 1.6.59.67.21 1.28.18 1.76.11.54-.08 1.64-.67 1.87-1.31.23-.64.23-1.19.16-1.31-.07-.12-.25-.19-.52-.33Z" />
                    <path d="M27.14 4.86A15.84 15.84 0 0 0 16.02.02C7.23.02.08 7.16.08 15.95c0 2.8.73 5.53 2.11 7.93L0 32l8.32-2.18a15.88 15.88 0 0 0 7.69 1.96h.01c8.79 0 15.94-7.15 15.94-15.94 0-4.26-1.66-8.26-4.82-10.98Zm-11.12 24.2h-.01a13.3 13.3 0 0 1-6.78-1.85l-.49-.29-4.94 1.29 1.32-4.81-.32-.5a13.27 13.27 0 0 1-2.05-7.06c0-7.34 5.97-13.31 13.31-13.31 3.55 0 6.88 1.38 9.39 3.9a13.2 13.2 0 0 1 3.9 9.4c0 7.34-5.98 13.32-13.33 13.32Z" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
     
   
    </div>
  );
}

export default Profile;
